module.exports = __webpack_public_path__ + "img/rajesh_n.cc2d9deb.png";